<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'MoreInfos' | lang }}</div>
    </header>
    <div  v-html="extraMobilePage"></div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'

export default {
  name: 'ExtraMobilePage',
  mixins: [ page ],
  mounted () {
    if (!this.extraMobilePage ) {
      this.goTo('/')
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';
</style>
